module.exports = __webpack_public_path__ + "static/media/sell_change_request_1.717d624b.png";